module.exports = __webpack_public_path__ + "img/map.c62eb89c.png";